/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HeoItemId } from './HeoItemId';
import {
    HeoItemIdFromJSON,
    HeoItemIdFromJSONTyped,
    HeoItemIdToJSON,
    HeoItemIdToJSONTyped,
} from './HeoItemId';

/**
 * 
 * @export
 * @interface CustomerOrderItemsByCustomerOrderSummary
 */
export interface CustomerOrderItemsByCustomerOrderSummary {
    /**
     * 
     * @type {HeoItemId}
     * @memberof CustomerOrderItemsByCustomerOrderSummary
     */
    heoItemId: HeoItemId;
    /**
     * 
     * @type {number}
     * @memberof CustomerOrderItemsByCustomerOrderSummary
     */
    quantity: number;
    /**
     * 
     * @type {number}
     * @memberof CustomerOrderItemsByCustomerOrderSummary
     */
    acceptedQuantity: number;
    /**
     * 
     * @type {number}
     * @memberof CustomerOrderItemsByCustomerOrderSummary
     */
    shippedQuantity: number;
    /**
     * 
     * @type {number}
     * @memberof CustomerOrderItemsByCustomerOrderSummary
     */
    pricePerUnit: number;
    /**
     * 
     * @type {number}
     * @memberof CustomerOrderItemsByCustomerOrderSummary
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof CustomerOrderItemsByCustomerOrderSummary
     */
    discount: number;
    /**
     * 
     * @type {string}
     * @memberof CustomerOrderItemsByCustomerOrderSummary
     */
    customerItemReference: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerOrderItemsByCustomerOrderSummary
     */
    productNumber: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerOrderItemsByCustomerOrderSummary
     */
    productName: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerOrderItemsByCustomerOrderSummary
     */
    productImageUrl: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerOrderItemsByCustomerOrderSummary
     */
    productThumbnailUrl: string;
}

/**
 * Check if a given object implements the CustomerOrderItemsByCustomerOrderSummary interface.
 */
export function instanceOfCustomerOrderItemsByCustomerOrderSummary(value: object): value is CustomerOrderItemsByCustomerOrderSummary {
    if (!('heoItemId' in value) || value['heoItemId'] === undefined) return false;
    if (!('quantity' in value) || value['quantity'] === undefined) return false;
    if (!('acceptedQuantity' in value) || value['acceptedQuantity'] === undefined) return false;
    if (!('shippedQuantity' in value) || value['shippedQuantity'] === undefined) return false;
    if (!('pricePerUnit' in value) || value['pricePerUnit'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('discount' in value) || value['discount'] === undefined) return false;
    if (!('customerItemReference' in value) || value['customerItemReference'] === undefined) return false;
    if (!('productNumber' in value) || value['productNumber'] === undefined) return false;
    if (!('productName' in value) || value['productName'] === undefined) return false;
    if (!('productImageUrl' in value) || value['productImageUrl'] === undefined) return false;
    if (!('productThumbnailUrl' in value) || value['productThumbnailUrl'] === undefined) return false;
    return true;
}

export function CustomerOrderItemsByCustomerOrderSummaryFromJSON(json: any): CustomerOrderItemsByCustomerOrderSummary {
    return CustomerOrderItemsByCustomerOrderSummaryFromJSONTyped(json, false);
}

export function CustomerOrderItemsByCustomerOrderSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomerOrderItemsByCustomerOrderSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'heoItemId': HeoItemIdFromJSON(json['heoItemId']),
        'quantity': json['quantity'],
        'acceptedQuantity': json['acceptedQuantity'],
        'shippedQuantity': json['shippedQuantity'],
        'pricePerUnit': json['pricePerUnit'],
        'total': json['total'],
        'discount': json['discount'],
        'customerItemReference': json['customerItemReference'],
        'productNumber': json['productNumber'],
        'productName': json['productName'],
        'productImageUrl': json['productImageUrl'],
        'productThumbnailUrl': json['productThumbnailUrl'],
    };
}

export function CustomerOrderItemsByCustomerOrderSummaryToJSON(json: any): CustomerOrderItemsByCustomerOrderSummary {
    return CustomerOrderItemsByCustomerOrderSummaryToJSONTyped(json, false);
}

export function CustomerOrderItemsByCustomerOrderSummaryToJSONTyped(value?: CustomerOrderItemsByCustomerOrderSummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'heoItemId': HeoItemIdToJSON(value['heoItemId']),
        'quantity': value['quantity'],
        'acceptedQuantity': value['acceptedQuantity'],
        'shippedQuantity': value['shippedQuantity'],
        'pricePerUnit': value['pricePerUnit'],
        'total': value['total'],
        'discount': value['discount'],
        'customerItemReference': value['customerItemReference'],
        'productNumber': value['productNumber'],
        'productName': value['productName'],
        'productImageUrl': value['productImageUrl'],
        'productThumbnailUrl': value['productThumbnailUrl'],
    };
}

